<template>
    <ls-modal :options="modals.termsOfService" @onModalClose="closeModal('termsOfService')">
        <div slot="header">
            <h3 class="ls-align--center ls-color--green ls-margin--top-none">Terms of Service</h3>
        </div>

        <div class="grid">
            <div class="grid__col-xs-12">
                <LlTosText v-if="isLawnLove" />
                <LsTosText v-if="isLawnStarter" />
                <HgTosText v-else />
            </div>
        </div>

        <div slot="button" class="grid">
            <div class="grid__col-12">
                <div>
                    <button
                        slot="button"
                        class="ls-float-right ls-button ls-button--white"
                        type="button"
                        @click="closeModal('termsOfService')"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    </ls-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import * as types from '@/store/types';
import lsModal from '@/components/original-mydot/modals/modal/Modal.vue';
import brandMixin from '@/mixins/brand.mixin';
import HgTosText from './HgTosText.vue';
import LlTosText from './LlTosText.vue';
import LsTosText from './LsTosText.vue';

export default {
    components: {
        HgTosText,
        lsModal,
        LsTosText,
        LlTosText,
    },
    mixins: [brandMixin],
    data() {
        return {};
    },
    computed: {
        ...mapState(['modals']),
    },
    methods: {
        ...mapActions({
            closeModal: types.MODAL__CLOSE_MODAL,
        }),
    },
};
</script>

<style lang="scss" scoped>
h3 {
    margin-top: rem(0);
}
</style>
